import React from 'react';
import { LevelData } from '../game/levels';

interface LevelSelectorProps {
  levels: LevelData[];
  currentLevelId: number;
  onSelectLevel: (levelId: number) => void;
}

export const LevelSelector: React.FC<LevelSelectorProps> = ({
  levels,
  currentLevelId,
  onSelectLevel,
}) => {
  const currentLevel = levels.find(l => l.id === currentLevelId);
  
  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <span style={styles.label}>Level:</span>
        <select
          value={currentLevelId}
          onChange={(e) => onSelectLevel(parseInt(e.target.value, 10))}
          style={styles.select}
        >
          {levels.map((level) => (
            <option key={level.id} value={level.id}>
              {level.title ? `${level.id}: ${level.title}` : level.id}
            </option>
          ))}
        </select>
      </div>
      {currentLevel?.author && (
        <div style={styles.author}>Level by {currentLevel.author}</div>
      )}
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  wrapper: {
    marginBottom: '20px',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  label: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#333',
  },
  select: {
    padding: '8px 12px',
    fontSize: '16px',
    borderRadius: '4px',
    border: '2px solid #4a4a4a',
    cursor: 'pointer',
    backgroundColor: '#fff',
  },
  author: {
    marginTop: '8px',
    fontSize: '14px',
    color: '#fff',
    fontStyle: 'italic',
  },
};